module.exports = __webpack_public_path__ + "static/media/foto_brahma_01.1da3b1ac.jpg";